<template>
  <div class="check-users-operate">
    <el-button type="info" plain size="mini" @click="cancel">取消</el-button>
    <el-button type="primary" :disabled="disable" size="mini" @click="operate">{{ operateName }}</el-button>
  </div>
</template>

<script>
export default {
  name: 'TeamMemberOperate',
  components: {
  },
  props: {
    disable: {
      type: Boolean,
      default: true
    },
    operateName: {
      type: String,
      default: '创建'
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    operate () {
      this.$emit('operate')
    }
  }
}
</script>

<style lang="stylus" scoped>
.check-users-operate {
  text-align: center;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/common/im/team/create/TeamMemberOperate.vue